import { createUseStyles } from 'react-jss'

import config from 'styles/config'
import { textSize, titleFont } from '@portal/kit/pkg/styles'

const ranActivateStyles = createUseStyles(theme => ({
  adTitle: {
    marginBottom: 6,
    ...titleFont(),
    ...textSize(16, 19),
  },
  adText: {
    marginBottom: 16,
    ...textSize(14, 19),
  },
  adImg: {
    display: 'block',
    marginBottom: 16,
    paddingBottom: '25%',
    backgroundImage: 'url(/images/WiFi-prive-desktop-v2.jpg)',
    backgroundSize: '100% auto',
    backgroundRepeat: 'no-repeat',
  },
  adAction: {
    textAlign: 'right',
  },
  [config.mediaQueries.tabletPortrait]: {
    adTitle: {
      ...textSize(18, 22),
    },
    adText: {
      marginBottom: 24,
    },
    adImg: {
      marginBottom: 20,
    },
  }
}))

export default ranActivateStyles
